var _path, _path2, _ellipse;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4219 33.0352C21.4219 23.0742 29.7211 14.9999 39.9581 14.9999C50.195 14.9999 58.4943 23.0742 58.4943 33.0352",
    stroke: "#3098F3",
    strokeWidth: 12,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.00508118 33.0352C0.00484085 33.077 0.00471878 33.1188 0.00471878 33.1607C0.00471826 44.9197 9.53728 54.4523 21.2963 54.4523C33.0553 54.4523 42.5879 44.9197 42.5879 33.1607C42.5879 33.1188 42.5878 33.077 42.5875 33.0352L0.00508118 33.0352Z",
    fill: "#FFCC00"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 58.2427,
    cy: 48.9409,
    rx: 5.76125,
    ry: 5.76125,
    transform: "rotate(90 58.2427 48.9409)",
    fill: "#FE6571"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIllustration);
export default __webpack_public_path__ + "static/media/icon-illustration.19b8d30d0e94d8fc7f383177f91e50f3.svg";
export { ForwardRef as ReactComponent };